import AgencySaleDialogView from 'features/Agency/components/AgencySaleDialogView';
import thunderBrickIcon from 'assets/icons/thunder-brick.svg';
import thunderIcon from 'assets/icons/thunder.svg';
import ChargeHelper, { ChargeConstants } from 'features/Charge/chargeHelper';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import DropdownTableConfigColumn from 'general/components/DropdownTableConfigColumn';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import KTPagination, {
  KTPaginationColor,
} from 'general/components/OtherKeenComponents/KTPagination';
import KTTable from 'general/components/OtherKeenComponents/KTTable';
import tableStyle from 'general/components/OtherKeenComponents/KTTable/tableStyle';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import ButtonFilterDropdown from 'general/components/quybka/Buttons/ButtonFilterDropdown';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import AppRoute from 'general/constants/AppRoute';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import useConfigTableColumn from 'hooks/useConfigTableColumn';
import useRouter from 'hooks/useRouter';
import useWindowSize from 'hooks/useWindowSize';
import _ from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import DialogAddVehicleView from '../DialogAddVehicleView';
import ChargeVehicleListFilterView from './components/ChargeVehicleListFilterView';
import AppConstants from 'general/constants/AppConstants';

ChargeVehicleListView.propTypes = {};

const defaultColumnIds = [
  'LOGO',
  'PLATE',
  'DRIVER',
  'STATUS',
  'VEHICLE_TYPE',
  'VEHICLE_BRAND',
  'VEHICLE_MODEL',
  'VIN_NUMBER',
  'ID_TAG',
  'CHARGING_MODE',
  'VEHICLE_IDENTITY_CODE',
];

function ChargeVehicleListView(props) {
  // MARK: ---- PROPERTIES ----
  const router = useRouter();
  const { user, permissionList } = useSelector((state) => state.auth);
  const isAdmin = user?.role === 'ADMIN' || user?.role === 'OPERATOR';
  const prefKey = useMemo(() => {
    const userId = user.userId;
    const pathName = router.pathname;
    const key = `${userId}_${pathName}`;
    return key;
  }, [user, router]);
  const insertColumnAfter = (columnIds = [], targetColumnId, columnIdToInsert) => {
    const nextColumnIds = columnIds.filter((columnId) => columnId !== columnIdToInsert);
    const targetColumnIndex = nextColumnIds.indexOf(targetColumnId);
    nextColumnIds.splice(
      targetColumnIndex >= 0 ? targetColumnIndex + 1 : nextColumnIds.length,
      0,
      columnIdToInsert
    );

    return nextColumnIds;
  };
  const ensureRequiredColumns = (columnIds = []) => {
    let nextColumnIds = [...columnIds];
    nextColumnIds = insertColumnAfter(nextColumnIds, 'STATUS', 'VEHICLE_TYPE');
    nextColumnIds = insertColumnAfter(nextColumnIds, 'ID_TAG', 'CHARGING_MODE');
    nextColumnIds = insertColumnAfter(nextColumnIds, 'CHARGING_MODE', 'VEHICLE_IDENTITY_CODE');

    return nextColumnIds;
  };
  useEffect(() => {
    const storedColumnIdsValue = localStorage.getItem(prefKey);
    if (!storedColumnIdsValue) {
      return;
    }

    const storedColumnIds = storedColumnIdsValue.split('|').filter(Boolean);
    const nextColumnIds = ensureRequiredColumns(storedColumnIds);

    if (nextColumnIds.join('|') !== storedColumnIds.join('|')) {
      localStorage.setItem(prefKey, nextColumnIds.join('|'));
    }

    const fullColumnKey = `${prefKey}_FULL_COLUMN_IDS`;
    const storedFullColumnIds = localStorage.getItem(fullColumnKey)?.split('|').filter(Boolean) || [];
    const nextFullColumnIds = ensureRequiredColumns(storedFullColumnIds);

    if (
      storedFullColumnIds.length > 0 &&
      nextFullColumnIds.join('|') !== storedFullColumnIds.join('|')
    ) {
      localStorage.setItem(fullColumnKey, nextFullColumnIds.join('|'));
    }
  }, [prefKey]);
  const [filter, setFilter] = useState(ChargeHelper.Filter.chargeVehicleList);
  const [chargeVehicleList, setChargeVehicleList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const isPlugAndChargeEnabled = (vehicle) =>
    vehicle?.chargingMode === ChargeConstants.VehicleChargingMode.SMART || vehicle?.autoCharge === true;
  useEffect(() => {
    setIsLoading(true);
    const params = _.pickBy(
      filter,
      (value) => value !== null && value !== undefined && value !== ''
    );
    if (params.autoCharge === 'true') {
      params.autoCharge = true;
    } else if (params.autoCharge === 'false') {
      params.autoCharge = false;
    }
    ChargeHelper.API.Vehicle.requestGetVehicleList(params)
      .then((response) => {
        setChargeVehicleList(response?.vehicles);
        setTotal(response?.total);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [filter]);
  const fullColumns = useMemo(() => {
    return [
      {
        id: 'LOGO',
        name: UIHelper.buildTableColumn('Ảnh xe'),
        selector: (row) =>
          UIHelper.buildAvatar(
            row?.model?.image ? Utils.getFullUrl(row?.model?.image) : null,
            40,
            AppResource.images.chargeConnectorTypes.vehicleDefault,
            false,
            false
          ),
        width: '70px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'PLATE',
        name: UIHelper.buildTableColumn('Biển số'),
        selector: (row) => row?.plate,
        minWidth: '180px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'DRIVER',
        name: UIHelper.buildTableColumn('Tên khách hàng'),
        selector: (row) => (
          <span
            className="cursor-pointer hover-opacity-60"
            onClick={() => {
              Utils.openInNewTab(`${AppRoute.customerList}/${row?.userId}`);
            }}
          >
            {row?.user?.fullname}
          </span>
        ),
        minWidth: '240px',
        style: tableStyle.columns.link,
      },
      {
        id: 'STATUS',
        name: UIHelper.buildTableColumn('Trạng thái'),
        selector: (row) => {
          return (
            <KTLabel
              text={ChargeHelper.Utils.getVehicleStatusName(row?.status)}
              isInline={true}
              size={KTLabelSize.medium}
              additionalClassName={`label-light-${ChargeHelper.Utils.getVehicleStatusColor(
                row?.status
              )}`}
            />
          );
        },
        minWidth: '180px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'VEHICLE_TYPE',
        name: UIHelper.buildTableColumn('Loại phương tiện'),
        selector: (row) =>
          _.find(
            ChargeHelper.Data.vehicleTypeOptions,
            (item) => item.value === row?.vehicleType
          )?.name || row?.vehicleType || '',
        minWidth: '160px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'VEHICLE_BRAND',
        name: UIHelper.buildTableColumn('Hãng xe'),
        selector: (row) => (
          <span
            className="cursor-pointer hover-opacity-60"
            onClick={() => {
              Utils.openInNewTab(`${AppRoute.manageVehicleBrand}/${row?.model?.brandId}`);
            }}
          >
            {row?.model?.brand?.name}
          </span>
        ),
        minWidth: '180px',
        style: tableStyle.columns.link,
      },
      {
        id: 'VEHICLE_MODEL',
        name: UIHelper.buildTableColumn('Dòng xe'),
        selector: (row) => (
          <span
            className="cursor-pointer hover-opacity-60"
            onClick={() => {
              Utils.openInNewTab(`${AppRoute.manageVehicleBrand}/${row?.model?.brandId}`);
            }}
          >
            {row?.model?.name}
          </span>
        ),
        minWidth: '180px',
        style: tableStyle.columns.link,
      },
      {
        id: 'VIN_NUMBER',
        name: UIHelper.buildTableColumn('Số khung'),
        selector: (row) => row?.vinNumber,
        minWidth: '180px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'ID_TAG',
        name: UIHelper.buildTableColumn('Mã ID Tag'),
        selector: (row) => {
          const activeCard = row?.cards?.find(card => card?.status === 'NORMAL');
          return (
            <div> {activeCard?.idTag}</div>
          )
        },
        minWidth: '180px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'CHARGING_MODE',
        name: UIHelper.buildTableColumn('Chế độ sạc'),
        selector: (row) =>
          isPlugAndChargeEnabled(row)
            ? 'Sạc nhận diện xe (Plug & Charge)'
            : 'Sạc thông thường',
        minWidth: '220px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'VEHICLE_IDENTITY_CODE',
        name: UIHelper.buildTableColumn('Mã MAC/EVCC'),
        selector: (row) => row?.vehicleIdentity?.code || '',
        minWidth: '180px',
        style: tableStyle.columns.normal,
      },
      {
        name: UIHelper.buildTableColumn('Thao tác'),
        maxWidth: '140px',
        style: {
          position: 'sticky',
          right: 0,
          backgroundColor: '#fff',
          borderLeft: '1px solid #ebedfe',
        },
        cell: (row) => {
          return UIHelper.buildMoreActionsButton(buildMoreActions(row), true);
        },
      },
    ];
  }, [user]);
  const [fullColumnIds, setFullColumnIds] = useState(
    fullColumns.filter(column => !column.omit).map(column => column.id).filter(Boolean) || []
  );
  const windowSize = useWindowSize();
  const {
    columnIds,
    columns,
    onChangeCheckboxValue,
    resetDefaultTableColumn,
    onSelectAll,
    onUnSelectAll,
    fullColumnsSorted,
    fullColumnsIdSorted,
    saveChanges,
  } = useConfigTableColumn(prefKey, fullColumnIds, defaultColumnIds, fullColumns);
  const ensuredColumnIds = useMemo(() => ensureRequiredColumns(columnIds), [columnIds]);
  const ensuredFullColumnIds = useMemo(
    () => ensureRequiredColumns(fullColumnsIdSorted),
    [fullColumnsIdSorted]
  );
  const displayColumns = useMemo(() => {
    const columnsById = new Map(fullColumns.filter((column) => column?.id).map((column) => [column.id, column]));
    const currentColumnsById = new Map(columns.filter((column) => column?.id).map((column) => [column.id, column]));
    const actionColumns = columns.filter((column) => !column?.id);

    return [
      ...ensureRequiredColumns(columns.filter((column) => column?.id).map((column) => column.id))
        .map((columnId) => currentColumnsById.get(columnId) || columnsById.get(columnId))
        .filter(Boolean),
      ...actionColumns,
    ];
  }, [columns, fullColumns]);
  const [selectedVehicleBrand, setSelectedVehicleBrand] = useState(null);
  const [selectedVehicleModel, setSelectedVehicleModel] = useState(null);
  const [defaultDropdownVehicleModel, setDefaultDropdownVehicleModel] = useState(null);
  useEffect(() => {
    setDefaultDropdownVehicleModel({
      name: 'Dòng xe',
      role: 'VEHICLE_MODEL',
      brandId: selectedVehicleBrand?.id,
    });
  }, [selectedVehicleBrand]);
  const dropdownVehicleBrandEl = useMemo(() => {
    return (
      <CustomDropdown2
        id="brandId"
        name="brandId"
        toggleElement={
          <button
            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
            type="button"
          >
            {selectedVehicleBrand?.name ?? 'Chọn hãng xe'}
          </button>
        }
        selectedValue={selectedVehicleBrand}
        dropdownMenuItems={[{ name: 'Hãng xe', role: 'VEHICLE_BRAND' }]}
        getSubItems={async (item) => {
          return ChargeHelper.API.VehicleBrand.requestGetVehicleBrandList({
            page: item?.page || 0,
            limit: 10,
            q: item?.q || '',
          }).then((data) => {
            return {
              values: data.brands?.map((row) => ({
                id: row?.brandId,
                name: row?.name,
                item: row,
              })),
              total: data.total,
            };
          });
        }}
        dropdownMenuStyle={{ maxHeight: '30vh' }}
        dropdownMenuClassName="overflow-auto w-100"
        onChange={(value) => {
          setSelectedVehicleBrand(value);
          setSelectedVehicleModel(null);
          ChargeHelper.Filter.chargeVehicleList = {
            ...ChargeHelper.Filter.chargeVehicleList,
            brandId: value?.id,
            page: 0,
          };
          handleRefresh();
        }}
        isDropdownForm={true}
        titleSearchable={true}
        searchable={true}
        searchFormClassName="mx-3 my-1 search-form-border"
        ignoreConfirmClick={true}
        defaultValue={{
          name: 'Hãng xe',
          role: 'VEHICLE_BRAND',
        }}
        footerEl={
          <div
            className="p-4 position-sticky sticky-bottom bg-white"
            style={{
              borderTop: `1px solid ${AppColors.gray[300]}`,
            }}
          >
            {UIHelper.buildNegativeButton('Bỏ chọn', () => {
              setSelectedVehicleBrand(null);
              setSelectedVehicleModel(null);
              ChargeHelper.Filter.chargeVehicleList = {
                ...ChargeHelper.Filter.chargeVehicleList,
                brandId: '',
                modelId: '',
                page: 0,
              };
              handleRefresh();
            })}
          </div>
        }
      />
    );
  }, [selectedVehicleBrand]);
  const dropdownVehicleModelEl = useMemo(() => {
    return (
      <CustomDropdown2
        id="modelId"
        name="modelId"
        toggleElement={
          <button
            className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${!selectedVehicleBrand ? 'disabled' : ''
              }`}
            type="button"
          >
            {selectedVehicleModel?.name ?? 'Chọn dòng xe'}
          </button>
        }
        selectedValue={selectedVehicleModel}
        dropdownMenuItems={[{ name: 'Dòng xe', role: 'VEHICLE_MODEL' }]}
        getSubItems={async (item) => {
          if (Utils.isValid(selectedVehicleBrand?.id))
            return ChargeHelper.API.VehicleModel.requestGetVehicleModelList(
              selectedVehicleBrand?.id,
              {
                page: item?.page || 0,
                limit: 10,
                q: item?.q || '',
              }
            ).then((data) => {
              return {
                values: data.models?.map((row) => ({
                  id: row?.modelId,
                  name: row?.name,
                  item: row,
                })),
                total: data.total,
              };
            });
        }}
        dropdownMenuStyle={{ maxHeight: '30vh' }}
        dropdownMenuClassName="overflow-auto w-100"
        onChange={(value) => {
          setSelectedVehicleModel(value);
          ChargeHelper.Filter.chargeVehicleList = {
            ...ChargeHelper.Filter.chargeVehicleList,
            modelId: value?.id,
            page: 0,
          };
          handleRefresh();
        }}
        isDropdownForm={true}
        titleSearchable={true}
        searchable={true}
        searchFormClassName="mx-3 my-1 search-form-border"
        ignoreConfirmClick={true}
        disabled={!selectedVehicleBrand}
        defaultValue={defaultDropdownVehicleModel}
        footerEl={
          <div
            className="p-4 position-sticky sticky-bottom bg-white"
            style={{
              borderTop: `1px solid ${AppColors.gray[300]}`,
            }}
          >
            {UIHelper.buildNegativeButton('Bỏ chọn', () => {
              setSelectedVehicleModel(null);
              ChargeHelper.Filter.chargeVehicleList = {
                ...ChargeHelper.Filter.chargeVehicleList,
                modelId: '',
                page: 0,
              };
              handleRefresh();
            })}
          </div>
        }
      />
    );
  }, [selectedVehicleBrand, selectedVehicleModel, defaultDropdownVehicleModel]);
  useEffect(() => {
    const brandId = ChargeHelper.Filter.chargeVehicleList?.brandId;
    if (brandId) {
      ChargeHelper.API.VehicleBrand.requestGetVehicleBrandList({ brandId }).then((data) => {
        if (data.brands?.length > 0) {
          setSelectedVehicleBrand({
            id: data.brands[0].brandId,
            name: data.brands[0].name,
          });
        }
      });

      const modelId = ChargeHelper.Filter.chargeVehicleList?.modelId;
      if (modelId) {
        ChargeHelper.API.VehicleModel.requestGetVehicleModelList(brandId, { modelId }).then(
          (data) => {
            if (data.models?.length > 0) {
              setSelectedVehicleModel({
                id: data.models[0].modelId,
                name: data.models[0].name,
              });
            }
          }
        );
      }
    }
  }, []);

  // MARK: ---- METHODS ----
  const buildMoreActions = (row) => {
    const actions = [];
    const isPlugAndChargeActive = isPlugAndChargeEnabled(row);
    // xem chi tiet
    if (Utils.checkPermission(permissionList, AppConstants.permissionCode.vehicleView.code)) {
      actions.push({
        text: 'Xem chi tiết',
        iconElement: <i className="fa-regular fa-eye" style={{ fontSize: '1.1rem' }} />,
        click: () => {
            router.navigate(`${row?.vehicleId}`, { state: { vehicle: row } });
        },
      });
    }
    if (isAdmin) {
      if (Utils.checkPermission(permissionList, AppConstants.permissionCode.vehicleUpdate.code)) {
        // chinh sua
        actions.push({
          text: 'Chỉnh sửa',
          iconElement: <i className="fa-regular fa-edit" style={{ fontSize: '1.1rem' }} />,
          click: () => {
            handleAddNew(row);
          },
        });
        actions.push({
          text: isPlugAndChargeActive
            ? 'Tắt sạc nhận diện xe (Plug & Charge)'
            : 'Bật sạc nhận diện xe (Plug & Charge)',
          iconElement: (
            <img
              src={isPlugAndChargeActive ? thunderBrickIcon : thunderIcon}
              alt=""
              style={{ width: '1.1rem', height: '1.1rem' }}
            />
          ),
          click: () => {
            handleTogglePlugAndCharge(row);
          },
        });
      }
      if (Utils.checkPermission(permissionList, AppConstants.permissionCode.vehicleDelete.code)) {
        // xoa
        actions.push({
          text: 'Xoá',
          iconElement: <i className="fa-regular fa-trash-can" style={{ fontSize: '1.1rem' }} />,
          click: () => {
            handleDelete(row);
          },
        });
      }
    }
    return actions;
  };

  const handleRefresh = () => {
    setFilter({ ...ChargeHelper.Filter.chargeVehicleList });
  };
  const handleDelete = (row) => {
    ChargeHelper.UI.Vehicle.showDialogConfirmDeleteVehicle(row, () => {
      handleRefresh();
    });
  };
  const handleTogglePlugAndCharge = (row) => {
    const isPlugAndChargeActive = isPlugAndChargeEnabled(row);
    if (!isPlugAndChargeActive) {
      const vehicleIdentityId =
        row?.vehicleIdentityId ?? row?.vehicleIdentity?.vehicleIdentityId ?? null;
      if (!Utils.isValid(vehicleIdentityId)) {
        ToastHelper.showError(ChargeConstants.VehicleFlugChargeRequiresRegistrationMessage);
        return;
      }
    }
    AppCustomDialogHelper.show(
      '',
      <AgencySaleDialogView
        iconEl={
          <img
            src={
              isPlugAndChargeActive
                ? AppResource.images.dialogIcons.dialogError
                : AppResource.images.dialogIcons.dialogSuccess
            }
          />
        }
        title={isPlugAndChargeActive ? 'Tắt sạc nhận diện xe' : 'Bật sạc nhận diện xe'}
        contentEl={
          <>
            Bạn có chắc muốn {isPlugAndChargeActive ? 'tắt' : 'bật'} tính năng sạc nhận diện xe
            (Plug &amp; Charge) cho xe{' '}
            <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray600)}>
              [{row?.plate}]
            </span>{' '}
            không?
          </>
        }
        cancelButtonText="Bỏ qua"
        confirmButtonText={isPlugAndChargeActive ? 'Tắt' : 'Xác nhận'}
        confirmButtonRed={isPlugAndChargeActive}
        onCancel={() => {
          AppCustomDialogHelper.hide();
        }}
        onConfirm={async () => {
            AppCustomDialogHelper.hide();

            const result = await ChargeHelper.API.Vehicle.requestUpdateVehicle(
              row?.vehicleId,
              {
                autoCharge: !isPlugAndChargeActive,
              }
            );

            if (result ===true) {
              ToastHelper.showSuccess(
                isPlugAndChargeActive
                  ? 'Đã tắt sạc nhận diện xe (Plug & Charge)'
                  : 'Đã bật sạc nhận diện xe (Plug & Charge)'
              );

              handleRefresh();
              return;
            }

            ToastHelper.showError(result || 'Có lỗi xảy ra');
          }}
      />,
      'md',
      true,
      true
    );
  };
  const handleAddNew = (row) => {
    AppCustomDialogHelper.show(
      !!row ? 'Sửa xe' : 'Thêm xe',
      <DialogAddVehicleView
        item={row}
        onCancel={() => AppCustomDialogHelper.hide()}
        onDone={() => {
          AppCustomDialogHelper.hide();
          handleRefresh();
        }}
      />,
      'lg',
      false,
      true
    );
  };

  return (
    <div>
      {UIHelper.buildCard(
        <div className="pb-4">
          {/* header */}
          <div className="px-4 pt-4 pb-4 d-flex align-items-center justify-content-between">
            {/* title */}
            <div className="d-flex flex-column">
              <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                Danh sách xe
              </span>
              <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                Tổng:{' '}
                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.primary)}>
                  {Utils.formatNumber(total)} xe
                </span>
              </span>
            </div>

            {/* actions */}
            {isAdmin && Utils.checkPermission(permissionList, AppConstants.permissionCode.vehicleCreate.code) &&
              UIHelper.buildGreenButton(
                'Thêm mới',
                handleAddNew,
                <i className="fa-regular fa-circle-plus" />
              )}
          </div>

          {/* table */}
          <div className="">
            {/* filter */}
            <div className="row m-0 p-0 px-2">
              {/* tim kiem */}
              {windowSize.width >= 768 && (
                <div className="col mb-4 px-2">
                  {UIHelper.buildFormLabel('Tìm kiếm')}
                  <KTFormSearch
                    name="search"
                    placeholder="Theo biển số xe, số khung..."
                    value={filter.q}
                    onSubmit={(text) => {
                      ChargeHelper.Filter.chargeVehicleList = {
                        ...ChargeHelper.Filter.chargeVehicleList,
                        q: text,
                        page: 0,
                      };
                      handleRefresh();
                    }}
                  />
                </div>
              )}
              {/* loc theo hang xe */}
              {windowSize.width >= 1120 && (
                <div className="col mb-4 px-2">
                  {UIHelper.buildFormLabel('Hãng xe')}
                  {dropdownVehicleBrandEl}
                </div>
              )}
              {/* loc theo dong xe */}
              {windowSize.width >= 1368 && (
                <div className="col mb-4 px-2">
                  {UIHelper.buildFormLabel('Dòng xe')}
                  {dropdownVehicleModelEl}
                </div>
              )}
              {/* loc theo che do sac */}
              {windowSize.width >= 1616 && (
                <div className="col mb-4 px-2">
                  {UIHelper.buildFormLabel('Chế độ sạc')}
                  <KTBSDropdown
                    name="autoCharge"
                    toggleElement={
                      <button
                        className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                        type="button"
                      >
                        {filter.autoCharge === 'true'
                          ? 'Sạc nhận diện xe'
                          : filter.autoCharge === 'false'
                            ? 'Sạc thông thường'
                            : 'Tất cả'}
                      </button>
                    }
                    selectedValue={filter.autoCharge ?? ''}
                    dropdownMenuItems={[
                      { name: 'Tất cả', value: '' },
                      { name: 'Sạc thông thường', value: 'false' },
                      { name: 'Sạc nhận diện xe', value: 'true' },
                    ]}
                    dropdownMenuClassName="overflow-auto w-100"
                    dropdownMenuStyle={{ maxHeight: '30vh' }}
                    onChange={(value) => {
                      ChargeHelper.Filter.chargeVehicleList = {
                        ...ChargeHelper.Filter.chargeVehicleList,
                        autoCharge: value,
                        page: 0,
                      };
                      handleRefresh();
                    }}
                    isDropdownForm={true}
                  />
                </div>
              )}
              {/* thiet lap cot */}
              <div className="col mb-4 px-2 d-flex align-items-end gap-3">
                {/* bo loc */}
                <ButtonFilterDropdown
                  dropdownContent={
                    <ChargeVehicleListFilterView
                      onCancel={() => {
                        handleRefresh();
                      }}
                      onApply={() => {
                        handleRefresh();
                      }}
                      initialSelectedBrand={selectedVehicleBrand}
                      initialSelectedModel={selectedVehicleModel}
                      onSelectedBrandChange={(value) => {
                        setSelectedVehicleBrand(value);
                      }}
                      onSelectedModelChange={(value) => {
                        setSelectedVehicleModel(value);
                      }}
                    />
                  }
                />
                <DropdownTableConfigColumn
                  columnIds={ensuredColumnIds}
                  fullColumns={fullColumns}
                  fullColumnIds={ensuredFullColumnIds}
                  showVehicleTypeWhenHideBike={true}
                  onChangeCheckboxValue={onChangeCheckboxValue}
                  resetDefaultTableColumn={resetDefaultTableColumn}
                  onChangeFullColumnIds={(ids) => {
                    setFullColumnIds(ids);
                    const key = prefKey + '_FULL_COLUMN_IDS';
                    localStorage.setItem(key, ids.join('|'));
                  }}
                  onSelectAll={onSelectAll}
                  onUnSelectAll={onUnSelectAll}
                  saveChanges={saveChanges}
                />
              </div>
            </div>

            <div className="px-4">
              <KTTable
                columns={displayColumns}
                items={chargeVehicleList}
                selectableRows={false}
                striped={false}
                compactGrid={false}
                showVehicleTypeWhenHideBike={true}
                onClickedRow={(row) => { }}
                onSelectedRowsChanged={(rows) => { }}
                onDoubleClickedRow={(row) => { }}
                noDataComponent={UIHelper.buildEmptyNoData(
                  'Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.'
                )}
              />
            </div>
          </div>

          {/* pagination */}
          <div className="px-4 mt-2">
            <KTPagination
              currentPage={filter.page + 1}
              rowCount={total}
              rowsPerPage={filter.limit}
              currentItemInPageCount={chargeVehicleList?.length}
              onChangePage={(newPage) => {
                const iNewPage = parseInt(newPage);
                ChargeHelper.Filter.chargeVehicleList = {
                  ...ChargeHelper.Filter.chargeVehicleList,
                  page: iNewPage - 1,
                };
                handleRefresh();
              }}
              onChangeRowsPerPage={(newRowsPerPage) => {
                const iNewRowsPerPage = parseInt(newRowsPerPage);
                ChargeHelper.Filter.chargeVehicleList = {
                  ...ChargeHelper.Filter.chargeVehicleList,
                  limit: iNewRowsPerPage,
                  page: 0,
                };
                handleRefresh();
              }}
              loading={false}
              color={KTPaginationColor.success}
              appendText="xe"
            />
          </div>
        </div>,
        false
      )}
    </div>
  );
}

export default ChargeVehicleListView;
